import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveAs } from 'file-saver';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
    search: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports',
                    method: 'GET',
                    types: [
                        types.SEARCH_REPORTS_REQUEST,
                        types.SEARCH_REPORTS_SUCCESS,
                        types.SEARCH_REPORTS_FAILURE
                    ]
                }
            });
        }
    },
    loadReportFilters: (reportId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/' + reportId,
                    method: 'GET',
                    types: [
                        types.LOAD_REPORT_FILTERS_REQUEST,
                        types.LOAD_REPORT_FILTERS_SUCCESS,
                        types.LOAD_REPORT_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationResponsibleUsers: (locationKeys) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/location-responsible-users',
                    method: 'POST',
                    body: {
                        locationKeys: locationKeys
                    },
                    types: [
                        types.LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_REQUEST,
                        types.LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_SUCCESS,
                        types.LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationsForCoach: (coachId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/coach-locations',
                    method: 'POST',
                    body: {
                        coachId: coachId
                    },
                    types: [
                        types.LOAD_COACH_LOCATIONS_FILTERS_REQUEST,
                        types.LOAD_COACH_LOCATIONS_FILTERS_SUCCESS,
                        types.LOAD_COACH_LOCATIONS_FILTERS_FAILURE
                    ]
                }
            });
        }
    },    
    saveReportFilterValues: (reportId, filterValues) => {
        return (dispatch) => {
            return dispatch({
                type: types.SAVE_REPORT_FILTER_VALUES,
                payload: {
                    reportId: reportId,
                    filterValues: filterValues
                }
            });
        }
    },
    viewReport: (reportRequest) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/view',
                    method: 'POST',
                    body: reportRequest,
                    types: [
                        types.VIEW_REPORT_REQUEST,
                        types.VIEW_REPORT_SUCCESS,
                        types.VIEW_REPORT_FAILURE
                    ]
                }
            });
        }
    },
    loadScheduleFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/schedule-filters',
                    method: 'GET',
                    types: [
                        types.LOAD_SCHEDULE_FILTERS_REQUEST,
                        types.LOAD_SCHEDULE_FILTERS_SUCCESS,
                        types.LOAD_SCHEDULE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    createScheduledReport: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/create-scheduled-report',
                    method: 'POST',
                    body: request,
                    types: [
                        types.CREATE_SCHEDULED_REPORT_REQUEST,
                        types.CREATE_SCHEDULED_REPORT_SUCCESS,
                        types.CREATE_SCHEDULED_REPORT_FAILURE
                    ]
                }
            });
        }
    },
    loadProjectDependentFilters: (reportId, projectId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `reports/project-filters/${reportId}/${projectId}`,
                    method: 'GET',
                    types: [
                        types.LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_REQUEST,
                        types.LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_SUCCESS,
                        types.LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    /**
     * Exporting requires access to the raw response and headers, so this function that
     * would typically be an action creator that dispatches a call through the API middleware
     * in api.js is instead directly calling fetch and processing the response with file-saver.js
     */
    exportReport: (reportRequest) => {
        return (dispatch, getState) => {
            const endpoint = 'reports/export';
            const method = 'POST';
            const body = JSON.stringify(reportRequest);
            let headers = {};
            headers['Content-Type'] = 'application/json';
            const token = getState().user.accessToken;
            if (typeof token === "string") {
                headers.Authorization = `Bearer ${token}`;
            }
            const subscriptionId = getState().user.currentSubscriptionId;
            if (subscriptionId) {
                headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
            }

            return (
                // eslint-disable-next-line no-undef
                fetch(`${API_ROOT}${endpoint}`, {
                    method,
                    body,
                    headers,
                    credentials: "same-origin"
                })
                    .then(response => {
                        if (response.ok) {
                            var disposition = response.headers.get('Content-Disposition');
                            var defaultFileName = '';
                            if (disposition) {
                                var match = disposition.match(/.*filename="?([^;"]+)"?.*/);
                                if (match[1])
                                    defaultFileName = match[1];
                            }
                            defaultFileName = defaultFileName.replace(/[<>:"/\\|?*]+/g, '_');

                            response.blob().then(blob => {
                                saveAs(blob, defaultFileName);
                            })
                        } else {
                            throw new Error(`${response.status} ${response.statusText}`);
                        }
                    })
            );
        }
    },
    loadScheduledReports: (showAll) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/scheduled-reports',
                    method: 'POST',
                    body: {
                        showAll: showAll ? true : false
                    },
                    types: [
                        types.LOAD_SCHEDULED_REPORTS_REQUEST,
                        types.LOAD_SCHEDULED_REPORTS_SUCCESS,
                        types.LOAD_SCHEDULED_REPORTS_FAILURE
                    ]
                }
            });
        }
    },
    deleteScheduledReport: (scheduledReportId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `reports/scheduled-report/${scheduledReportId}`,
                    method: 'DELETE',
                    types: [
                        types.DELETE_SCHEDULED_REPORT_REQUEST,
                        types.DELETE_SCHEDULED_REPORT_SUCCESS,
                        types.DELETE_SCHEDULED_REPORT_FAILURE
                    ]
                }
            });
        }
    },
    loadScheduledReport: (scheduledReportId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `reports/scheduled-report/${scheduledReportId}`,
                    method: 'GET',
                    types: [
                        types.LOAD_SCHEDULED_REPORT_REQUEST,
                        types.LOAD_SCHEDULED_REPORT_SUCCESS,
                        types.LOAD_SCHEDULED_REPORT_FAILURE
                    ]
                }
            });
        }
    },
    updateScheduledReport: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'reports/update-scheduled-report',
                    method: 'POST',
                    body: request,
                    types: [
                        types.UPDATE_SCHEDULED_REPORT_REQUEST,
                        types.UPDATE_SCHEDULED_REPORT_SUCCESS,
                        types.UPDATE_SCHEDULED_REPORT_FAILURE
                    ]
                }
            });
        }
    }
}

